export default __webpack_public_path__ + "static/media/CNo.76-7.996a35b3.jpg";